import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { mapPlaylistCardToContentCardItem, openPlaylistCard } from '@app/app/shared/collections/card-item/card-item-content-card.mapper';
import { cardItemJoin } from '@app/app/shared/collections/card-item/card-item-join';
import { V3ContentCardComponent } from '@app/app/shared/components-v3/content-card/v3-content-card.component';
import { V3ContentCardRow } from '@app/app/shared/components-v3/content-card/v3-content-card.model';
import { PlaylistCardShort } from '@app/app/shared/models';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'ptl-card-item-list-view',
  standalone: true,
  imports: [V3ContentCardComponent],
  templateUrl: './card-item-list-view.component.html',
  styleUrls: ['./card-item-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardItemListViewComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly activeLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  card = input.required<PlaylistCardShort>();
  cardIndex = input(0);
  reservedRows = input<V3ContentCardRow[]>([]);

  cardClick = output<PlaylistCardShort>();

  protected readonly join = cardItemJoin(this.card);

  protected readonly cardItem = computed(() => {
    this.activeLang();
    return mapPlaylistCardToContentCardItem(this.join.card(), this.cardIndex(), this.transloco);
  });

  onCardOpen(): void {
    openPlaylistCard(this.card(), (card) => this.cardClick.emit(card));
  }
}
